var map = {
	"./bh-ico-active.svg": 1779,
	"./bh-ico.svg": 1780,
	"./bonus-ico-active.svg": 1781,
	"./bonus-ico.svg": 1782,
	"./deposit-ico.svg": 1783,
	"./deposit-ico.webp": 1784,
	"./edit-icon.svg": 1785,
	"./fb-ico.svg": 1786,
	"./instant-rebate-ico-active.svg": 1787,
	"./instant-rebate-ico.svg": 1788,
	"./mall-ico-active.svg": 1789,
	"./mall-ico.svg": 1790,
	"./msg-ico-active.svg": 1791,
	"./msg-ico.svg": 1792,
	"./pi-ico-active.svg": 1793,
	"./pi-ico.svg": 1794,
	"./rf-ico-active.svg": 1795,
	"./rf-ico.svg": 1796,
	"./rh-ico-active.svg": 1797,
	"./rh-ico.svg": 1798,
	"./th-ico-active.svg": 1799,
	"./th-ico.svg": 1800,
	"./vip-ico-active.svg": 1801,
	"./vip-ico.svg": 1802,
	"./withdrawal-ico.svg": 1803,
	"./withdrawal-ico.webp": 1804,
	"./wl-ico-active.svg": 1805,
	"./wl-ico.svg": 1806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 468;